import _ from 'underscore';

import {DataFrame, DataFrameRow} from 'data-frames/DataFrameTypes';

/**
 * Return a data frame that includes a random sample without replacement of the rows in the given data frame.
 * The size of sample is determined by the parameter `n`, and if `n >= rows.length`, all rows will be returned
 * in a random order.
 */
export default function sampleRows(dataFrame: DataFrame, n: number): DataFrame {
  return {
    ...dataFrame,
    rows: _.shuffle<DataFrameRow>(dataFrame.rows).slice(0, n),
  };
}
